import { WParagraph, WTitle, WButton } from '@alice-health/wonderland-react'
import { FunctionComponent, ReactNode } from 'react'
import { useMediaQuery } from '@/global/hooks'
import { Action } from './ErrorTemplate.types'

interface ErrorTemplateProps {
  active: boolean
  title: ReactNode
  description: string
  actions: Action[]
}

const ErrorTemplate: FunctionComponent<ErrorTemplateProps> = ({
  active,
  title,
  description,
  actions
}) => {
  const isMobile = useMediaQuery({ maxWidth: 'mobile' })

  if (!active) return null

  return (
    /*
     * O handoff alinha o bloco a esquerda, no topo do que sobra da lista. O
     * recuo horizontal vem da coluna da pagina, para o bloco ficar na mesma
     * margem dos chips e dos cards.
     */
    <div className='w-full flex flex-col items-start gap-gl-spacing-08 py-gl-spacing-10 sm:pt-gl-spacing-06 sm:pb-gl-spacing-12'>
      <div className='w-full flex flex-col items-start gap-gl-spacing-04 sm:gap-gl-spacing-03'>
        <WTitle size={isMobile ? 'small' : 'medium'}>{title}</WTitle>

        <WParagraph
          size='medium'
          mode='tertiary'
        >
          {description}
        </WParagraph>
      </div>

      {actions.length ? (
        <div className='w-full flex flex-col gap-gl-spacing-02 sm:flex-row sm:w-fit sm:gap-gl-spacing-04'>
          {actions.map(action => (
            <WButton
              key={action.label}
              className='w-full *:w-full sm:w-fit'
              variant={action.variant}
              size={action.size}
              onClick={action.onClick}
              block={action.block}
              icon={action.icon}
            >
              {action.label}
            </WButton>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export { ErrorTemplate }
